/**
 * Format amount for display with currency symbol.
 * @param {number} value - Amount (major units unless inMinor)
 * @param {string} currency - USD, EUR, or GBP
 * @param {{ inMinor?: boolean }} options - inMinor: true if value is in cents
 */
const SYMBOLS = { USD: '$', EUR: '€', GBP: '£' };
export function formatCurrency(value, currency = 'USD', options = {}) {
  if (value == null || typeof value !== 'number') return '—';
  const { inMinor } = options;
  const num = inMinor ? value / 100 : value;
  const symbol = SYMBOLS[currency] || currency + ' ';
  if (num >= 1000) return `${symbol}${(num / 1000).toFixed(1)}k`;
  return `${symbol}${num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}
